export const STORAGE = {
  pdfDocument: 'pdfDocument',
  uploadedFile: 'uploadedFile',
  authToken: 'authToken',
  isOpenTour: 'isOpenTour',
};
